var map = {
	"./animals.svg": "bde4",
	"./beauty.svg": "4425",
	"./plant.svg": "0f5f",
	"./vehicles.svg": "2e27",
	"./weather.svg": "1c20",
	"./wedding.svg": "3d0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1282";